// question types
export const QUESTION_CHECKBOX = 'check';
export const QUESTION_RADIO = 'radio';
